<template>
  <div class="container page bind-card-page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar bind-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>

    <div class="page-body">
      <div class="form-card">
        <div class="field-block">
          <div class="field-label">*{{$t("setting.username")}}</div>
          <div class="field-input">
            <van-field
              v-model="username"
              :value="this.username"
              :placeholder="$t('setting.username_place')"
            />
          </div>
        </div>

        <div class="field-block">
          <div class="field-label">*{{$t("setting.band_name")}}</div>
          <div class="field-input">
            <van-field
              v-model="bank"
              :placeholder="$t('setting.band_name_tip')"
            />
          </div>
        </div>

        <div class="field-block">
          <div class="field-label">*{{$t("setting.branch_name")}}</div>
          <div class="field-input">
            <van-field
              v-model="bankfenhang"
              :placeholder="$t('setting.branch_name_tip')"
            />
          </div>
        </div>

        <div class="field-block">
          <div class="field-label">*{{$t("setting.branch_code")}}</div>
          <div class="field-input">
            <van-field
              v-model="fhnumber"
              :placeholder="$t('setting.branch_code_tip')"
            />
          </div>
        </div>

        <div class="field-block">
          <div class="field-label">*{{$t("setting.band_account")}}</div>
          <div class="field-input">
            <van-field
              v-model="bankid"
              :placeholder="$t('setting.band_account_tip')"
            />
          </div>
        </div>
      </div>

      <p class="warn-text">{{$t("setting.bank_warn")}}</p>
    </div>

    <div class="submit-wrap">
      <div @click="bindCard()" class="submit-btn">{{$t("setting.bank_ok")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      username:"",
      mobile:"",
      bank:"",
      bank_code: "",
      bankfenhang: '',
      fhnumber:""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
     
      if(this.userInfo.bankid){
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      if(this.userInfo.bankid){
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }

      if(this.username===""){
        this.$toast(this.$t("setting.username_place"));
        return false;
      }
      if(this.bankfenhang===""){
        this.$toast(this.$t("setting.branch_name_tip"));
        return false;
      }
      if(this.fhnumber===""){
        this.$toast(this.$t("setting.branch_code_tip"));
        return false;
      }

     
    
      this.$http({
        method: 'post',
        data:{
          bankid:this.bankid,
          bank:this.bank,
          // bank_code: this.bank_code,
          username: this.username,
          bankfenhang: this.bankfenhang,
          fhnumber:this.fhnumber
         
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.bank_code = value.value
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){this.bankid=res.data.info.bankid;this.bank=res.data.info.bankinfo;this.bankfenhang=res.data.info.bankfenhang;this.fhnumber=res.data.info.fhnumber;this.username=res.data.info.username;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.bind-card-page {
  min-height: 100%;
  background: #f5f5f5;
}

.van-cell {
  font-size: 32px;
  line-height: 52px;
  padding: 0;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.page-body {
  padding: 14px 16px 0;
}

.form-card {
  background-color: #fff;
  padding: 8px 24px 18px;
}

.field-block {
  padding: 18px 0 10px;
  border-bottom: 1px solid #ededed;
}

.field-block:last-child {
  border-bottom: none;
}

.field-label {
  margin-bottom: 12px;
  color: #666;
  font-size: 24px;
  line-height: 34px;
  font-weight: 600;
}

.field-input {
  padding: 18px 0;
  border-bottom: 1px solid #f1f1f1;
}

.field-block:last-child .field-input {
  border-bottom: none;
}

::v-deep .van-picker__toolbar {
  height: 50px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}

.warn-text {
  margin: 22px 0 0;
  padding: 0 6px;
  font-size: 24px;
  line-height: 34px;
  color: #ee0a24;
}

.submit-wrap {
  padding: 130px 16px 44px;
}

.submit-btn {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 999px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  background: linear-gradient(90deg, #6667e8 0%, #5d63e1 100%);
}

::v-deep .bind-nav {
  background: #fff;
}

::v-deep .bind-nav .van-nav-bar__title {
  color: #000;
  font-weight: 500;
}

::v-deep .bind-nav::after {
  border-bottom: 1px solid #ededed;
}

.nav-back {
  color: #8795ad;
}

::v-deep .field-input .van-field__control {
  color: #000;
  font-size: 32px;
}

::v-deep .field-input .van-field__control::placeholder {
  color: #b8b8b8;
}
</style>
